<template lang="pug">
.wrap
  table.table
    thead
      tr
        th.empty-cell
        th(v-for='(name, index) in header', @mouseenter='setCursor(0, index)')
          .hbutton(@click='openCellMenu') {{ name }}
    tbody
      tr(v-for='(row, rIndex) in block.value')
        td.empty-row(@mouseenter='setCursor(rIndex, 0)')
          .hbutton(@click='openRowMenu') {{ rIndex + 1 }}
        td(
          v-for='(cell, cIndex) in row',
          :class='{ "has-header": hasCellHeader(cell) }'
        )
          v-text-field(
            :value='cell.value',
            @click='setCursor(rIndex, cIndex)',
            @input='updateCellValue($event, rIndex, cIndex)'
          )
  v-dialog(v-model='cellMenu', max-width='400px')
    v-card
      v-list
        v-list-tile(
          @click='addCol({ position: "right" }); closeCellMenu()',
          ripple,
          avatar
        )
          v-list-tile-title Добавить столбец справа
        v-list-tile(
          @click='addCol({ position: "left" }); closeCellMenu()',
          ripple,
          avatar
        )
          v-list-tile-title Добавить столбец слева
        v-list-tile(
          @click='removeCol(); closeCellMenu()',
          v-if='!canRemoveCol',
          ripple,
          avatar
        )
          v-list-tile-title Удалить столбец
  v-dialog(v-model='rowMenu', max-width='400px')
    v-card
      v-list
        v-list-tile(
          @click='addRow({ position: "top" }); closeRowMenu()',
          ripple,
          avatar
        )
          v-list-tile-title Добавить строку выше
        v-list-tile(
          @click='addRow({ position: "bottom" }); closeRowMenu()',
          ripple,
          avatar
        )
          v-list-tile-title Добавить строку ниже
        v-list-tile(
          @click='createHeader(); closeRowMenu()',
          v-if='!hasHeader',
          ripple,
          avatar
        )
          v-list-tile-title Преобразовать в заголовок
        v-list-tile(
          @click='removeHeader(); closeRowMenu()',
          v-if='hasHeader',
          ripple,
          avatar
        )
          v-list-tile-title Отменить преобразование в заголовок
        v-list-tile(
          @click='removeRow(); closeRowMenu()',
          v-if='!canRemoveRow',
          ripple,
          avatar
        )
          v-list-tile-title Удалить строку
</template>

<script>
import BaseBlock from './BaseBlock'
import get from 'lodash/get'

export default {
  extends: BaseBlock,

  data: () => ({
    cursor: [0, 0],
    cellMenu: false,
    rowMenu: false,
  }),

  methods: {
    setCursor(r, c) {
      this.cursor = [r, c]
    },

    openCellMenu() {
      this.cellMenu = true
    },

    closeCellMenu() {
      this.cellMenu = false
    },

    openRowMenu() {
      this.rowMenu = true
    },

    hasCellHeader(cell) {
      return get(cell, 'attrs.header', false)
    },

    closeRowMenu() {
      this.rowMenu = false
    },

    removeCol() {
      // eslint-disable-next-line
      const [_, c] = this.cursor
      const cmatrix = [...this.matrix]
      this.setMatrix(cmatrix.map((row) => row.filter((_, i) => i !== c)))
    },

    removeRow() {
      const [r] = this.cursor
      this.setMatrix(this.matrix.filter((_, i) => i !== r))
    },

    addRow({ position }) {
      const [r] = this.cursor
      const cmatrix = [...this.matrix]

      const insertIndex = position === 'bottom' ? r + 1 : r
      // prettier-ignore
      const resultRow = Array(this.maxRowLength).fill(null).map(getCellTemplate)

      cmatrix.splice(insertIndex, 0, resultRow)
      this.setMatrix(cmatrix)
    },

    addCol({ position }) {
      // eslint-disable-next-line
      const [_, c] = this.cursor
      const cmatrix = [...this.matrix]

      const insertIndex = position === 'right' ? c + 1 : c

      const results = cmatrix.map((row) => {
        const crow = [...row]
        crow.splice(insertIndex, 0, getCellTemplate())
        return crow
      })

      this.setMatrix(results)
    },

    createHeader() {
      const [r] = this.cursor
      const cmatrix = [...this.matrix]

      cmatrix[r].map((cell) => {
        cell.attrs || (cell.attrs = {})
        cell.attrs.header = true
        return cell
      })

      this.setMatrix(cmatrix)
    },

    removeHeader() {
      const [r] = this.cursor
      const cmatrix = [...this.matrix]

      cmatrix[r].map((cell) => (cell.attrs.header = false))
      this.setMatrix(cmatrix)
    },

    setMatrix(matrix) {
      this.block.value = matrix
      this.$emit('update', this.block)
    },

    updateCellValue(value, r, c) {
      const target = this.getCell(r, c)
      if (target) {
        this.block.value[r][c] = { ...target, value }
        this.$emit('update', this.block)
      }
    },

    getCell(r, c) {
      return this.block.value[r][c]
    },
  },

  computed: {
    matrix() {
      return this.block.value
    },

    header() {
      const range = [...Array(this.maxRowLength).keys()]
      return range.map((key) => getColumnName(key))
    },

    maxRowLength() {
      const matrix = this.matrix
      return matrix.map((row) => row.length).sort()[matrix.length - 1]
    },

    canRemoveRow() {
      const matrix = this.matrix
      return matrix.length === 1
    },

    canRemoveCol() {
      const matrix = this.matrix
      return matrix[0].length === 1
    },

    hasHeader() {
      let _hasHeader = false
      let [selectedRowIndex] = this.cursor

      selectedRowIndex || (selectedRowIndex = 0)

      if (this.matrix[selectedRowIndex]) {
        _hasHeader = this.matrix[selectedRowIndex].some((cell) =>
          get(cell, 'attrs.header', false)
        )
      }

      return _hasHeader
    },
  },
}

const getCellTemplate = () => ({
  value: '',
  attrs: { colSpan: 1 },
})

const getColumnName = (i) => {
  const previousLetters = i >= 26 ? getColumnName(Math.floor(i / 26) - 1) : ''
  const lastLetter = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'[i % 26]
  return previousLetters + lastLetter
}
</script>

<style scoped>
.table {
  width: 100%;
  border-collapse: collapse;
}
.table td {
  border: solid 1px #ccc;
}
.table td >>> .v-input__slot {
  margin: 0;
}
.table td >>> .v-input {
  margin-top: 0;
}
.table td >>> .v-text-field {
  padding-top: 0px;
}
.table td >>> .v-input input {
  padding-bottom: 8px;
  padding-left: 10px;
  padding-right: 10px;
  font-size: 14px;
}
.table td >>> .v-input__slot:before {
  border: 0;
}
.table tr:first-child td {
  border-top: 0;
}
.table tr:last-child td {
  border-bottom: 0;
}
.table tr td:last-child {
  border-right: 0;
}
.table tr td:first-child {
  border-left: 0;
}
.hbutton {
  min-width: 40px;
  font-weight: bold;
  cursor: pointer;
  padding: 5px;
  padding-left: 10px;
  padding-right: 10px;
  background: #eee;
  font-size: 14px;
}
.hbutton:hover {
  background: #e2e2e2;
}
.table th {
  text-align: left;
  padding-left: 0px;
  padding-right: 0px;
  border-bottom: solid 1px #ccc;
  border-right: solid 1px #ccc;
}
.table th:last-child {
  border-right: 0;
}
.empty-row,
.empty-cell {
  background: #eee;
}
.empty-row:hover {
  background: #e2e2e2;
}
.has-header {
  font-weight: bold;
}
</style>
